import React from 'react';
import * as Sentry from '@sentry/react';
import {
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
} from 'react-router-dom';

export function setEmailToScope(userEmail: string): void {
    Sentry.withScope((scope): void => {
        scope.setUser({ email: userEmail });
    });
}

function getEnvironment() {
    if (window.location.origin.includes('localhost')) {
        return 'dev';
    }

    if (window.location.origin.includes('.dev')) {
        return 'staging';
    }

    return 'production';
}

const environment = getEnvironment();

export function initSentry(): void {
    Sentry.init({
        dsn: process.env.SENTRY_DSN,
        environment,
        integrations: [
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect: React.useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
            Sentry.captureConsoleIntegration({
                levels: ['error'],
            }),
        ],
        tracesSampleRate: 0.5,
        enabled: environment !== 'dev',
    });
}
